import { Virtuoso } from 'react-virtuoso';

import useTranslations from '@/i18n/useTranslations';
import Text from '@/shared-components/text/components/Text';

import MyRating from './components/MyRating';
import RatingCard from './components/RatingCard';

import './index.css';

const RATING_SUMMARY_ITEMS = [
  {
    key: 'emotions',
    category: 'Emotions',
    text: 'How strongly does this artwork provoke an emotional response in you? Consider the feeling it creates, whether quiet, intense, beautiful, unsettling, or unexpected.',
    averageKey: 'emotions_average',
  },
  {
    key: 'style',
    category: 'Style',
    text: 'How compelling is the artist’s visual execution? Consider composition, color, technique, originality, and the clarity of the artistic direction.',
    averageKey: 'style_average',
  },
  {
    key: 'time_travel',
    category: 'Time travel',
    text: 'How likely is this artwork to stand the test of time? Consider whether it could remain meaningful, memorable, or relevant to people beyond this moment.',
    averageKey: 'time_travel_average',
  },
];

export default function VirtualList({ ratingsData, onLoadMore, isGallery }) {
  const t = useTranslations('common.shared.artwork_view.socials.ratings.list');
  const ratings = Array.isArray(ratingsData?.data) ? ratingsData.data : [];
  const hasRatings = ratings.length > 0;
  const shouldLoadMore = ratings.length < (ratingsData?.totalDocs ?? 0);
  const myRatingValues = ratingsData?.my_rating?.rating_values ?? {};

  return (
    <>
      <Virtuoso
        className="artwork-ratings__container remove-scrollbar"
        style={{ width: '100%', height: '100%' }}
        data={ratings}
        endReached={shouldLoadMore ? onLoadMore : undefined}
        increaseViewportBy={300}
        components={{
          Header: () => (
            <>
              {!isGallery && (
                <>
                  {RATING_SUMMARY_ITEMS.map(({ key, category, text, averageKey }) => (
                    <MyRating
                      key={key}
                      category={category}
                      text={text}
                      myRating={myRatingValues[key]}
                      averageRating={ratingsData[averageKey]}
                    />
                  ))}
                </>
              )}

              {!hasRatings && isGallery && (
                <Text
                  className="artwork-ratings__see-other-ratings font-size-small flex items-center justify-center"
                  paragraph
                >
                  {t('empty_gallery')}
                </Text>
              )}

              {hasRatings && !isGallery && (
                <Text className="artwork-ratings__see-other-ratings font-size-small" paragraph>
                  {t('others_rated')}
                </Text>
              )}
            </>
          ),
          Footer: () => <div className="artwork-ratings__bottom-spacer" aria-hidden="true" />,
        }}
        itemContent={(index, rating) => (
          <div className="artwork-ratings__list-item">
            <RatingCard
              myRatingData={ratingsData.my_rating}
              ratingData={rating}
              isGallery={isGallery}
            />
          </div>
        )}
      />
    </>
  );
}
